

import { EntityDto, IEntityDto } from "../../../utils/models/entity-dto";
import { FieldType } from "@gbs-platform-client/fwk-core";


export class MeetingMaster extends EntityDto implements IEntityDto {
 Meeting_Id: string;
 MeetingType_Id: string;
 MeetingTypeName:string;
 MeetingName: string;
 MeetingDescription: string;

 
  IsActive: boolean;
  Emp_Ref_Id: string;
  EmployeeName: string;
  TotalCount: number;

  constructor() {
    super();
    this.Meeting_Id = '00000000-0000-0000-0000-000000000000';
    this.MeetingDescription = '';
    this.MeetingName = '';
this.MeetingType_Id='';''
this.MeetingTypeName=''
   
    this.Emp_Ref_Id = '';
    this.EmployeeName = '';
    this.TotalCount = 0;
    this.IsActive = true;

    this.EntityMetaData = [
    
      { FieldName: 'Meeting_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Meeting  is required' },
     { FieldName: 'MeetingName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Meeting is required' },
     
     { FieldName: 'MeetingDescription', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Meeting Description is required' },
    
    ];
  }
}